module.exports = __webpack_public_path__ + "static/media/ico_orgullo_pride.6ed821ef.png";